import { useEffect, useState } from 'react';
import Seo from './components/Seo';
import Header from './components/Header';
import Hero from './components/Hero';
import KeyFacts from './components/KeyFacts';
import FormPanel from './components/FormPanel';
import TrustStrip from './components/TrustStrip';
import Services from './components/Services';
import OptimizationCalculator from './components/OptimizationCalculator';
import Process from './components/Process';
import WhyUs from './components/WhyUs';
import References from './components/References';
import FAQ from './components/FAQ';
import ServiceArea from './components/ServiceArea';
import Contact from './components/Contact';
import ClosingCTA from './components/ClosingCTA';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import StickyCTA from './components/StickyCTA';
import ExitIntentModal from './components/ExitIntentModal';
import { BUSINESS } from './data/business';
import { faqJsonLd } from './components/FAQ';

const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  additionalType: 'https://schema.org/ProfessionalService',
  name: BUSINESS.name,
  description: 'KI-Beratung für mittelständische Unternehmen in Österreich: KI-Automatisierung und Kostenoptimierung.',
  url: BUSINESS.url,
  telephone: BUSINESS.phoneMachine,
  email: BUSINESS.email,
  address: {
    '@type': 'PostalAddress',
    streetAddress: BUSINESS.address.street,
    postalCode: BUSINESS.address.postalCode,
    addressLocality: BUSINESS.address.locality,
    addressCountry: BUSINESS.address.countryCode,
  },
  areaServed: BUSINESS.areaServed,
  openingHoursSpecification: {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: BUSINESS.hours.days,
    opens: BUSINESS.hours.opens,
    closes: BUSINESS.hours.closes,
  },
};

const jsonLd = [localBusinessSchema, faqJsonLd];

export default function App() {
  const [currentSection, setCurrentSection] = useState('hero');

  useEffect(() => {
    const sections = ['hero', 'services', 'process', 'why-us', 'references', 'contact'];

    const handleScroll = () => {
      for (const sectionId of sections) {
        const element = document.getElementById(sectionId);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 200 && rect.bottom >= 200) {
            setCurrentSection(sectionId);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <Seo
        title="KI Beratung Österreich für Unternehmen | OptiAI Wien"
        description="KI-Beratung für mittelständische Unternehmen (50–500 MA) in Österreich: KI-Automatisierung & Kostenoptimierung, erfolgsbasiert. Kostenloses Erstgespräch."
        canonicalPath="/"
        jsonLd={jsonLd}
      />
      <div className="min-h-screen bg-white dark:bg-gray-950">
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary focus:text-white focus:rounded-lg"
        >
          Zum Inhalt springen
        </a>
        <Header />
        <main id="main-content">
          <Hero />
          <KeyFacts />
          <FormPanel />
          <TrustStrip />
          <Services />
          <OptimizationCalculator />
          <Process />
          <WhyUs />
          <References />
          <FAQ />
          <ServiceArea />
          <Contact />
          <ClosingCTA />
        </main>
        <Footer />
        <CookieConsent />
        <StickyCTA currentSection={currentSection} />
        <ExitIntentModal />
      </div>
    </>
  );
}
